<script setup lang="ts">
const { isVisible, close } = usePickerBackdrop();

const handleDocumentClick = (event: MouseEvent) => {
  if (!isVisible.value) return;
  
  const target = event.target as Element;
  
  // Don't close if clicking inside a v-calendar popover
  const isInsideVCal = target.closest('.vc-popover-content-wrapper, .vc-popover-content, .vc-container, .vc-pane-container, .vc-time-picker, .vc-time-select-group');
  if (isInsideVCal) {
    return;
  }
  
  // Don't close if clicking on a picker button (z-[9999])
  const isPickerButton = target.closest('.z-\\[9999\\]');
  if (isPickerButton) {
    return;
  }
  
  close();
};

onMounted(() => {
  document.addEventListener('click', handleDocumentClick, true);
});

onUnmounted(() => {
  document.removeEventListener('click', handleDocumentClick, true);
});
</script>

<template>
  <!-- No backdrop div needed - using document click listener -->
</template>

<style>
/* Ensure v-calendar popovers have high z-index */
.vc-popover-content-wrapper {
  z-index: 10000 !important;
}
</style>
